import React, {useEffect} from 'react';
import CustomScrollbars from 'util/CustomScrollbars';
import Navigation from "../../components/prefabricated/Navigation";
import {useDispatch, useSelector} from "react-redux";
import {
    bbDoesUserHaveAccessToBreachRiskLevelForAnyEntity,
    bbDoesUserHaveAccessToModule, bbFindCustomerTagsByTagId,
    getFirstCustomerId,
    isCurrentUserMemberOf
} from "../../util/bbHelpers";
import IntlMessages from "../../util/IntlMessages";
// import {Tooltip} from "@material-ui/core";
import {BRCustomizedTooltip as Tooltip} from "../../components/customBreachBits/accents/BRCustomizedTooltip";
import BBIconFlaskBeta from "../../assets/bbCustomIcons/BBIconFlaskBeta";
import BBIconInsideHousePerson from "../../assets/bbCustomIcons/BBIconInsideHousePerson";
import BBIconAnalysisNetwork from "../../assets/bbCustomIcons/BBIconAnalysisNetwork";
import BBIconShieldStar from "../../assets/bbCustomIcons/BBIconShieldStar";
import BBIconCapitolBuilding from "../../assets/bbCustomIcons/BBIconCapitolBuilding";
import BBIconHistory from "../../assets/bbCustomIcons/BBIconHistory";
import BBIconChevronRightExternalThreat from "../../assets/bbCustomIcons/BBIconChevronRightExternalThreat";
import BBIconBreachRiskScore from "../../assets/bbCustomIcons/BBIconBreachRiskScore";
import BBIconFolderSettings from "../../assets/bbCustomIcons/BBIconFolderSettings";
import BBIconVerified from "../../assets/bbCustomIcons/BBIconVerified";
import BBIconSendAirplane from "../../assets/bbCustomIcons/BBIconSendAirplane";
import BBIconLightBulb from "../../assets/bbCustomIcons/BBIconLightBulb";
import BBIconGraphChart from "../../assets/bbCustomIcons/BBIconGraphChart";
import BBIconCloudSecurity from "../../assets/bbCustomIcons/BBIconCloudSecurity";
import BBIconAttestation from "../../assets/bbCustomIcons/BBIconAttestation";
import BBIconTechData from "../../assets/bbCustomIcons/BBIconTechData";
import BBIconConstructionTie from "../../assets/bbCustomIcons/BBIconConstructionTie";
import {fetchCustomers, setCustomerInView} from "../../actions";
import { List} from "@mui/material";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import {NavLink} from "reactstrap";
import BBIconPhishingHookEmail from "../../assets/bbCustomIcons/BBIconPhishingHookEmail";
import BBIconAccountTrustedAgent from "../../assets/bbCustomIcons/BBIconAccountTrustedAgent";
import BBIconAddNetwork from "../../assets/bbCustomIcons/BBIconAddNetwork";
import BBIconAddCloud from "../../assets/bbCustomIcons/BBIconAddCloud";

const SideBarContent = () => {

  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
  // const dispatch = useDispatch();

  // const customers = useSelector(({customer}) => customer.customers);
  const authUser = useSelector(({auth}) => auth.authUser);
    const { customers, customerInView, loadingCustomers } = useSelector(({customer})=> customer);
    const customer = customers ? customerInView ? customers[customerInView]: customers[customerInView] : null

    const subscriptions = customer && Object.values(customer.Subscriptions)
    // console.log("Sidebar going through subscriptions", subscriptions, customers, customerInView);
    const hasActiveBRPSubscription = subscriptions && subscriptions.filter((sub)=> sub.subscription_type && sub.subscription_type.id === 1 && sub.is_active).length;
    const hasActiveBRfBSubscription = subscriptions && subscriptions.filter((sub)=> sub.subscription_type && sub.subscription_type.id === 2 && sub.is_active).length;
    // const hasActiveCIRTSubscription = subscriptions && subscriptions.filter((sub)=> sub.subscription_type && sub.subscription_type.id === 0 && sub.is_active).length;

    const authUserCustomerArray = authUser && authUser.customers && Array.isArray(authUser.customers)
        ? authUser.customers
        : null;

    const userCustomerObjectInView = authUserCustomerArray
        && authUserCustomerArray.find((customer)=> customer.customer === customerInView)

    const authUserIsManager = userCustomerObjectInView && userCustomerObjectInView.manager;

    const dispatch = useDispatch();

    useEffect(() => {
        // console.log("Targets Table for customerId: ", customerId, " customer: ", customer, " activeTargets: ", activeTargets)
        // console.log("TargetsTable here is the metaTargets store", metaTargets)
        if (!customers && !loadingCustomers) {
            // console.log("Customers is empty, fetching.")
            dispatch(fetchCustomers());
        } else if (customers && customerInView === null) {
            const defaultId = getFirstCustomerId(customers);
            // console.log("setting view to default customer, first in list: ", defaultId);
            dispatch(setCustomerInView(defaultId));
        }
        // console.groupEnd()
    }, [customers, customerInView, dispatch, loadingCustomers]);


    /**************************/
  /*END Setup State and Dispatch*/
  /**************************/

  /**************************/
  // STEP 1: CREATE THE MENU ITEM ONCE
  /* Each menu group should be created once. Each menu item should be created once.
  Then the user is evaluated and groups and menu items are added.
   */
  /**************************/

  /**************************/
  /*MAIN DASHBOARD
  /**************************/

  // const menuGroupDashboard = {
  //   name: 'blank.space',
  //   type: 'section',
  //   icon: null,
  //   children: []
  // };

  // const menuItemDashboard = {
  //   name: <><IntlMessages id={'pages.dashboard'}/></>,
  //   type: 'item',
  //   icon: 'view-dashboard', //https://zavoloklom.github.io/material-design-iconic-font/icons.html use those strings for icons
  //   link: '/board/dashboard',
  //   className: "tourStepDashboardMenu"
  // }

  // const menuItemWelcomeAboard = {
  //   name: 'sidebar.extraPages.welcomeAboard',
  //   type: 'item',
  //   icon: 'plus', //https://zavoloklom.github.io/material-design-iconic-font/icons.html use those strings for icons
  //   link:'/board/welcome'
  // }

    // const menuGroupSettings = {
    //     name: 'blank.space',
    //     type: 'section',
    //     icon: null,
    //     children: []
    // };

    const menuItemSettings = {
        name: <><IntlMessages id={'pages.settings.settings'}/></>,
        type: 'item',
        // icon: <BBIconSettings className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
        link:'/board/settings/account',
        className: "tourStepAccountSettingsMenuItem",
    }

    const menuItemManageSubscription = {
        name: <><IntlMessages id={'pages.settings.manage'}/>
            <Tooltip title={<IntlMessages id={'misc.beta'}/>}><span
            className="text-light-grey float-right"><BBIconFlaskBeta style={{fontSize: "20px"}} /></span></Tooltip></>,
        type: 'item',
        // icon: <BBIconSettings className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
        link:'/board/settings/subscription',
        className: 'tourStepManageSubscriptionMenuItem',
    }

    /**************************/
    /*BREACHRISK PORTFOLIO
    /**************************/

    const menuGroupBRPortfolio = {
        name: 'section.BRPortfolio',
        type: 'section',
        icon: null,
        className: "tourStepBRPortfolioMenuSection",
        children: []
    }

    // const menuItemBRPortfolioScore = {
    //     name: <><Tooltip title={<IntlMessages id={'pages.BRPortfolioScore.description'}/>}><span><IntlMessages id={'pages.BRPortfolioScore'}/> </span></Tooltip></>,
    //     type: 'item',
    //     icon: <BBIconDashboardGaugeLayout className={"zmdi zmdi-hc-fw"} style={{padding:0, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
    //     link: '/board/BreachRisk/Portfolio/Overview',
    //     className: "tourStepBRPortfolioScore"
    // }

    const menuItemBRPortfolioTrends = {
        name: <><IntlMessages id={'pages.BRPortfolioTrends'}/></>,
        type: 'item',
        icon: <BBIconLightBulb className={"zmdi zmdi-hc-fw"} style={{padding:0, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
        link: '/board/BreachRisk/Portfolio/Insights',
        className: "tourStepBRPortfolioTrends"
    }

    // const menuCollapseBRPortfolioInsights = {
    //     name: <><Tooltip title={<IntlMessages id={'pages.BRPortfolioInsights.description'}/>}><span><IntlMessages id={'pages.BRPortfolioInsights'}/> </span></Tooltip></>,
    //     type: 'collapse',
    //     icon: <BBIconAnalysisNetwork className={"zmdi zmdi-hc-fw"} style={{padding:0, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
    //     className: "tourStepBRPortfolioInsightsMenuCollapse",
    //     children: []
    // }

    const menuItemBRPortfolioInsightsScore = {
        name: <><IntlMessages id={'pages.BRPortfolioInsightsScore'}/></>,
        type: 'item',
        icon: <BBIconBreachRiskScore className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
        link: '/board/BreachRisk/Portfolio/Details/Scores',
        className: "tourStepBRPortfolioInsightsScores"
    }
    const menuItemBRPortfolioInsightsReport = {
        name: <><IntlMessages id={'pages.BRPortfolioInsightsReport'}/></>,
        type: 'item',
        icon: <BBIconGraphChart className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
        link: '/board/BreachRisk/Portfolio/Details/Reports',
        className: "tourStepBRPortfolioInsightsReports"
    }

    const menuItemBRPortfolioInsightsTechDataForAdmins = {
        name: <><IntlMessages id={'pages.BRPortfolioInsightsTechnical'}/><Tooltip title={"Only Admins can see this menu option."}><span className="float-right"><BBIconConstructionTie style={{fontSize: "18px"}} /></span></Tooltip></>,
        type: 'item',
        icon: <BBIconTechData className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
        link: '/board/BreachRisk/Portfolio/Details/TechData',
        className: ""
    }

    const menuItemBRPortfolioInsightsTechDataForPartners = {
        name: <><IntlMessages id={'pages.BRBusinessReportTechData'}/><Tooltip title={"Only Trusted Agents can see this menu option."}><span className="float-right"><BBIconAccountTrustedAgent style={{fontSize: "18px"}} /></span></Tooltip></>,
        type: 'item',
        icon: <BBIconTechData className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
        link: '/board/BreachRisk/Portfolio/Details/TechData',
        className: "tourStepBRPortfolioTechData"
    }

    const menuItemBRPortfolioSocialForPartners = {
        name: <><IntlMessages id={'pages.BRBusinessReportSocial'}/><Tooltip title={"Only Trusted Agents can see this menu option."}><span className="float-right"><BBIconAccountTrustedAgent style={{fontSize: "18px"}} /></span></Tooltip></>,
        type: 'item',
        icon: <><BBIconPhishingHookEmail className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/></>,
        link: '/board/BreachRisk/Portfolio/Details/Social',
        className: "tourStepBRBusinessReportSocial"
    }

    const menuItemBRPortfolioVerificationsForPartners = {
        name: <><IntlMessages id={'pages.BRBusinessVerifications'}/><Tooltip title={"Only Trusted Agents can see this menu option."}><span className="float-right"><BBIconAccountTrustedAgent style={{fontSize: "18px"}} /></span></Tooltip></>,
        type: 'item',
        icon: <BBIconAddNetwork className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
        link: '/board/BreachRisk/Portfolio/Details/Verifications',
        className: "tourStepBRPortfolioVerifications"
    }

    const menuItemBRPortfolioAttestationsForPartners = {
        name: <><IntlMessages id={'pages.BRBusinessAttestations'}/><Tooltip title={"Only Trusted Agents can see this menu option."}><span className="float-right"><BBIconAccountTrustedAgent style={{fontSize: "18px"}} /></span></Tooltip></>,
        type: 'item',
        icon: <BBIconAttestation className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
        link: '/board/BreachRisk/Portfolio/Attestations',
        className: "tourStepBRPortfolioAttestation"
    }

    const menuItemBRPortfolioCloudIntegrationForPartners = {
        name: <><IntlMessages id={'pages.BRBusinessCloudIntegration'}/><Tooltip title={"Only Trusted Agents can see this menu option."}><span className="float-right"><BBIconAccountTrustedAgent style={{fontSize: "18px"}} /></span></Tooltip></>,
        type: 'item',
        icon: <><BBIconAddCloud className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/></>,
        link: '/board/BreachRisk/Portfolio/CloudIntegration',
        className: "tourStepBRPortfolioCloudIntegration"
    }

    const menuItemBRPortfolioManage = {
        name: <><IntlMessages id={'pages.BRPortfolioManage'}/></>,
        type: 'item',
        icon: <BBIconFolderSettings className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
        link: '/board/BreachRisk/Portfolio/Manage',
        className: "tourStepBRPortfolioManage"
    }

    /**************************/
    /*BREACHRISK FOR BUSINESS
    /**************************/

    const menuGroupBRBusiness = {
        name: 'section.BRBusiness',
        type: 'section',
        icon: null,
        className: "tourStepBRBusinessMenuSection",
        children: []
    }


    const menuItemBRBusinessScore = {
        name: <><IntlMessages id={'pages.BRBusinessScore'}/></>,
        type: 'item',
        icon: <BBIconBreachRiskScore className={"zmdi zmdi-hc-fw"} style={{padding:0, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
        link: '/board/BreachRisk/Business/Score',
        className: "tourStepBRBusinessScore"
    }

    // const menuCollapseBRBusinessReport = {
    //     name: <><Tooltip title={<IntlMessages id={'pages.BRBusinessReport.description'}/>}><span><IntlMessages id={'pages.BRBusinessReport'}/> </span></Tooltip></>,
    //     type: 'collapse',
    //     icon: <BBIconReportDark className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
    //     className: "tourStepBRBusinessReportMenuCollapse",
    //     children: []
    // }

    const menuItemBRBusinessReportOverview = {
        name: <><IntlMessages id={'pages.BRBusinessReport'}/></>,
        type: 'item',
        icon: <BBIconGraphChart className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
        link: '/board/BreachRisk/Business/Report/Overview',
        className: "tourStepBRBusinessReportOverview"
    }

    // const menuCollapseTechData = {
    //     name: 'collapse.TechData',
    //     type: 'collapse',
    //     icon: <BBIconTechData className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
    //     className: "tourStepInspectorsMenuCollapse",
    //     children: []
    // }

    const menuItemBRBusinessReportTechData = {
        name: <><IntlMessages id={'pages.BRBusinessReportTechData'}/></>,
        type: 'item',
        icon: <BBIconTechData className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
        link: '/board/BreachRisk/Business/Report/TechData',
        className: "tourStepBRBusinessReportTechData"
    }

    const menuItemBRBusinessSocial = {
        name: <><IntlMessages id={'pages.BRBusinessReportSocial'}/></>,
        type: 'item',
        icon: <><BBIconPhishingHookEmail className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/></>,
        link: '/board/BreachRisk/Business/Report/Social',
        className: "tourStepBRBusinessReportSocial"
    }

    // const menuItemBRBusinessVectorInspector = {
    //     name: <><Tooltip title={<IntlMessages id={'pages.BRBusinessReportVectorInspector.description'}/>}><span><IntlMessages id={'pages.BRBusinessReportVectorInspector'}/> </span></Tooltip></>,
    //     type: 'item',
    //     icon: '',
    //     link: '/board/BreachRisk/Business/Report/VectorInspector',
    //     className: "tourStepBRBusinessReportVectorInspector"
    // }

    const menuItemBRBusinessVerifications = {
        name: <><IntlMessages id={'pages.BRBusinessVerifications'}/></>,
        type: 'item',
        icon: <BBIconAddNetwork className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
        link: '/board/BreachRisk/Business/Verifications',
        className: "tourStepBRBusinessVerifications"
    }

    const menuItemBRBusinessAttestations = {
        name: <><IntlMessages id={'pages.BRBusinessAttestations'}/></>,
        type: 'item',
        icon: <BBIconAttestation className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
        link: '/board/BreachRisk/Business/Attestations',
        className: "tourStepBRBusinessAttestations"
    }

    const menuItemBRBusinessCloudIntegration= {
        name: <><IntlMessages id={'pages.BRBusinessCloudIntegration'}/></>,
        type: 'item',
        icon: <><BBIconAddCloud className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/></>,
        link: '/board/BreachRisk/Business/CloudIntegration',
        className: "tourStepBRBusinessCloudIntegration"
    }

    // const menuCollapseBRBusinessShare = {
    //     name: <><Tooltip title={<IntlMessages id={'pages.BRBusinessShare.description'}/>}><span><IntlMessages id={'pages.BRBusinessShare'}/> </span></Tooltip></>,
    //     type: 'collapse',
    //     icon: <BBIconSendAirplane className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
    //     className: "tourStepBRBusinessShareMenuCollapse",
    //     children: []
    // }

    const menuItemBRBusinessShareCurrent = {
        name: <><IntlMessages id={'pages.BRBusinessShareCurrent'}/></>,
        type: 'item',
        icon: <BBIconSendAirplane className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
        link: '/board/BreachRisk/Business/Share/Current',
        className: "tourStepBRBusinessShareCurrent"
    }

    // const menuItemBRBusinessShareInquiries = {
    //     name: <><Tooltip title={<IntlMessages id={'pages.BRBusinessShareInquiries.description'}/>}><span><IntlMessages id={'pages.BRBusinessShareInquiries'}/> </span></Tooltip></>,
    //     type: 'item',
    //     //icon: <BBIconSendAirplane className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
    //     link: '/board/BreachRisk/Business/Share/Inquiries',
    //     className: "tourStepBRBusinessShareInquiries"
    // }
    //
    // const menuItemBRBusinessShareTools = {
    //     name: <><Tooltip title={<IntlMessages id={'pages.BRBusinessShareTools.description'}/>}><span><IntlMessages id={'pages.BRBusinessShareTools'}/> </span></Tooltip></>,
    //     type: 'item',
    //     //icon: <BBIconSendAirplane className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
    //     link: '/board/BreachRisk/Business/Share/Tools',
    //     className: "tourStepBRBusinessShareTools"
    // }

    /**************************/
    /*CIRT
    /**************************/

  const menuGroupCIRT = {
    name: 'section.cirt',
    type: 'section',
    icon: null,
    className: "tourStepCIRTMenuSection",
    children: []
  }

  const menuItemPerimeterModule = {
      name: <><IntlMessages id={'pages.perimeter'}/></>,
    type: 'item',
    icon: <BBIconChevronRightExternalThreat className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
    link: '/board/CIRT/external',
    className: "tourStepExternalThreats"
  }

    //beta icon
    //<Tooltip title={<IntlMessages id={'misc.beta'}/>}><span className="text-primary float-right"><BBIconFlaskBeta style={{fontSize: "22px"}} /></span></Tooltip>

  const menuItemInsiderThreatModule = {
    name: <><IntlMessages id={'pages.aod'}/>
        {/*<Tooltip title={<IntlMessages id={'misc.beta'}/>}><span className="text-primary float-right"><BBIconFlaskBeta style={{fontSize: "22px"}} /></span></Tooltip>*/}
    </>,
    type: 'item',
    icon: <BBIconInsideHousePerson className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
    link: '/board/CIRT/insider',
    className: "tourStepInternalThreats"
  }


  const menuItemCIRTEventLog = {
    name: <IntlMessages id={'pages.events'}/>,
        type: 'item',
      icon: <BBIconHistory className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
      link: '/board/CIRT/events',
      className: "tourStepEventHistory"
  }

    /*  jfd*******************************
     *   INSPECTORS
         ********************************** */

    const menuCollapseInspectors = {
        name: 'collapse.inspectors',
        type: 'collapse',
        icon: <BBIconAnalysisNetwork className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
        className: "tourStepInspectorsMenuCollapse",
        children: []
    }

    const menuItemAttackInspector = {
        name: <><IntlMessages id={'pages.attackInspector'}/>
            {/*<Tooltip title={<IntlMessages id={'misc.beta'}/>}><span className="text-primary float-right"><BBIconFlaskBeta style={{fontSize: "22px"}} /></span></Tooltip>*/}
        </>,
        type: 'item',
        icon: null,
        link: '/board/CIRT/inspector',
        className: "tourStepAttackInspector"
    }

    /*  jfd*******************************
     *   PARTNER MENUS
         ********************************** */

    const menuGroupPartnerFunctions = {
        name: 'section.partner',
        type: 'section',
        icon: null,
        children: []
    };

    /*  jfd*******************************
     *   ADMIN AND STAFF MENUS
         ********************************** */

  const menuGroupAdminFunctions = {
    name: 'section.admin',
    type: 'section',
    icon: null,
    children: []
  };

    const menuCollapseAdmin = {
        name: 'collapse.admin',
        type: 'collapse',
        icon: 'wrench',
        className: "tourStepInspectorsMenuCollapse",
        children: []
    }

  const menuItemAdminDashboard =  {
        name: 'pages.adminDashboard',
        type: 'item',
        icon: null,
        link:'/board/admin/dashboard'
      };

    const menuItemAdminExternal = {
        name: 'pages.adminExternal',
        type: 'item',
        icon: null,
        link: '/board/admin/external'
    }

    const menuItemAdminInternal = {
        name: 'pages.adminInternal',
        type: 'item',
        icon: null,
        link: '/board/admin/internal'
    }

    const menuItemAdminSocial = {
        name: 'pages.adminSocial',
        type: 'item',
        icon: null,
        link: '/board/admin/social'
    }

  const menuItemManageUsers = {
        name: 'pages.manageUsers',
        type: 'item',
        icon: 'accounts-list',
        link:'/board/admin/users'
      };

  const menuItemManageClients = {
        name: 'pages.manageClients',
        type: 'item',
        icon: 'city-alt',
        link:'/board/admin/clients'
      }

    /*  jfd*******************************
     *   COMPLIANCE MENUS
         ********************************** */

  const menuGroupCompliance = {
    name: 'section.compliance',
    type: 'section',
    icon: null,
    children: [

    ]
  };

    const menuItemComplianceNist171 = {
        name: <><IntlMessages id={'pages.nist171'}/><Tooltip title={<IntlMessages id={'misc.alpha'}/>}><span
            className="text-light-grey float-right"><BBIconFlaskBeta style={{fontSize: "20px"}} /></span></Tooltip></>,
        type: 'item',
        icon: <BBIconCapitolBuilding className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
        link: '/board/compliance/nist-171',
        className: ""
    }

  const menuItemComplianceCmmc = {
    name: <><IntlMessages id={'pages.cmmc'}/><Tooltip title={<IntlMessages id={'misc.alpha'}/>}><span
        className="text-light-grey float-right"><BBIconFlaskBeta style={{fontSize: "20px"}} /></span></Tooltip></>,
        type: 'item',
      icon: <BBIconShieldStar className={"zmdi zmdi-hc-fw"} style={{padding:2, marginRight:9, marginLeft: -2, marginTop: -4}}/>,
      link: '/board/compliance/cmmc',
      className: ""
  }

  /*  jfd*******************************
   *   Miscellaneous menus
       ********************************** */

  const menuGroupMore = {
    name: 'section.more',
    type: 'section',
    icon: null,
    children: []
  };

  const menuItemUserGuide = {
        name: <IntlMessages id={'pages.cirtusermanual'}/>,
        type: 'item',
        icon: null, //'help',
        link: '/board/userguide',
        className: "tourStepCIRTManual"
      };

  const menuItemFAQ = {
        name: 'sidebar.extraPages.faq',
        type: 'item',
        link:'/board/faq',
      className: "tourStepFAQMenu"
      };

    const menuItemKnowledgeBase = {
        name: <Tooltip title={"Browse our knowledge base in a new tab."}><span><IntlMessages id={'sidebar.extraPages.knowledgeBase'}/></span></Tooltip>,
        type: 'item',
        link: 'https://support.breachbits.com/knowledge',
        className: "tourStepKnowledgeBaseMenu",
        isExternalLink: true
    };

  const menuItemContactUs = {
        name: 'sidebar.extraPages.contactUs',
        type: 'item',
        link:'/board/contact',
      className: "tourStepContactMenu"
      };


  // const miscMenuWithWelcomeAboard = {
  //   name: 'section.more',
  //   type: 'section',
  //   icon: null,
  //   children: [
  //     // {
  //     //   name: 'sidebar.extraPages.welcomeAboard',
  //     //   type: 'item',
  //     //   link:'/board/welcome'
  //     // },
  //       {
  //       name: 'sidebar.extraPages.faq',
  //       type: 'item',
  //       link:'/board/faq'
  //     },
  //
  //     {
  //       name: 'sidebar.extraPages.contactUs',
  //       type: 'item',
  //       link:'/board/contact'
  //     },
  //     // {
  //     //   name: 'sidebar.extraPages.aboutUs',
  //     //   type: 'item',
  //     //   link:'/board/about'
  //     // }
  //   ]
  // };


  /*  jfd*******************************
  STEP 2: DETERMINE WHO WILL HAVE ACCESS TO THAT MENU ITEM
   *   Add menus based on role and subscription
   *   A user should see the menu if they 1) have the appropriate role (breachrisk = BRfB and breachrisk_portfolio = BRP) and 2) they have an active subscription for BRP/BRfB
       ********************************** */

  // navigationMenus is the array that will be built and finally added at the end
  let navigationMenus = [
    //miscMenu, //show if user is active
  ];

  const isAdminRole = isCurrentUserMemberOf(authUser,"admin");
  const isStaffRole = isCurrentUserMemberOf(authUser,"staff");
  const isAdminOrStaffRole = isAdminRole || isStaffRole;
  const isPartnerRole = isCurrentUserMemberOf(authUser,"partner");
  // const isCustomer =  hasActiveCIRTSubscription
    const hasBRPortfolioSubscription =  hasActiveBRPSubscription;
    const hasBRfBSubscription =  hasActiveBRfBSubscription;
  // const isCustomerRole = isCurrentUserMemberOf(authUser,"customer");
    const isBRPRole = isCurrentUserMemberOf(authUser,"breachrisk_portfolio");
    const isBRfBRole = isCurrentUserMemberOf(authUser,"breachrisk");

    const dontDoSocialTags = bbFindCustomerTagsByTagId(customer, 80);
    const dontDoSocial = dontDoSocialTags && dontDoSocialTags.length > 0; //if there is at least one dont social tag, then qualifies
    // console.log("checking for social tag within SideBarContent.js", "customer", customer, "dontDoSocialTags", dontDoSocialTags, "dontDoSocial", dontDoSocial);


    //functional menus are for active users only that meet the following criteria
  //   console.log("Building menus with authUser", authUser, "isCustomer", isCustomer, "isBRPRole", isBRPRole, "isBRfBRole", isBRfBRole);
  if (
      //if their user account is marked as active

      authUser && authUser.user && authUser.user.is_active &&
      (
          //if they are a customer (or partner and have at least one customer in list)
          ((
              hasBRfBSubscription
              // || isCustomerRole
              || hasBRPortfolioSubscription
              || isPartnerRole
              || isBRPRole
              || isBRfBRole
          ) && authUser.customers.length)
          // or if they are an admin
          || isAdminRole
          || isStaffRole
      )
  ) {
    /*  jfd*******************************
 *   first group: overall dashboard (and welcome maybe)
     ********************************** */
      // if(!(hasBRPortfolioSubscription || hasBRfBSubscription)) {
      //     menuGroupDashboard.children.push(menuItemDashboard);

          //add the overall menu groups
      //     navigationMenus.push(menuGroupDashboard);
      // }

      /*  jfd*******************************
     *   BreachRisk™ Portfolio menu items
     *   - must have BRP role and BRP subscription
         ********************************** */
      let hasBRPortfolioMenuItems = false; //set this to true if user has anything here to add

      //all admins for testing and dev
      if(isAdminOrStaffRole || (hasBRPortfolioSubscription && isBRPRole)) {
          hasBRPortfolioMenuItems = true;

          // menuGroupBRPortfolio.children.push(menuItemBRPortfolioScore);
          menuGroupBRPortfolio.children.push(menuItemBRPortfolioTrends);

          menuGroupBRPortfolio.children.push(menuItemBRPortfolioInsightsScore);
          menuGroupBRPortfolio.children.push(menuItemBRPortfolioInsightsReport);


          //Admins only can also see the tech data report
          if(isAdminRole) {
              menuGroupBRPortfolio.children.push(menuItemBRPortfolioInsightsTechDataForAdmins);
          } else if(bbDoesUserHaveAccessToBreachRiskLevelForAnyEntity(authUser, "infoLevel4")){
              menuGroupBRPortfolio.children.push(menuItemBRPortfolioInsightsTechDataForPartners);
              menuGroupBRPortfolio.children.push(menuItemBRPortfolioSocialForPartners);
              menuGroupBRPortfolio.children.push(menuItemBRPortfolioVerificationsForPartners);
              menuGroupBRPortfolio.children.push(menuItemBRPortfolioCloudIntegrationForPartners);
              menuGroupBRPortfolio.children.push(menuItemBRPortfolioAttestationsForPartners);
          }else if(bbDoesUserHaveAccessToBreachRiskLevelForAnyEntity(authUser, "infoLevel3")) {
              //People with data level 3 only can also see the tech data report
              menuGroupBRPortfolio.children.push(menuItemBRPortfolioInsightsTechDataForPartners);
              menuGroupBRPortfolio.children.push(menuItemBRPortfolioSocialForPartners);
              menuGroupBRPortfolio.children.push(menuItemBRPortfolioVerificationsForPartners);
              menuGroupBRPortfolio.children.push(menuItemBRPortfolioCloudIntegrationForPartners);
          }

          menuGroupBRPortfolio.children.push(menuItemBRPortfolioManage);
      }

      //add the menu group if one of the modules above was added
      if (hasBRPortfolioMenuItems) {
          navigationMenus.push(menuGroupBRPortfolio);
      }


      /*  jfd*******************************
*   BreachRisk™ for Business menu items
*   - must have BRfB role and BRfB subscription
   ********************************** */
      let hasBRBusinessMenuItems = false; //set this to true if user has anything here to add

      //all admins for testing and dev
      if(isAdminOrStaffRole || (hasBRfBSubscription && isBRfBRole)) {
          hasBRBusinessMenuItems = true;

          menuGroupBRBusiness.children.push(menuItemBRBusinessScore);
          menuGroupBRBusiness.children.push(menuItemBRBusinessReportOverview);
          menuGroupBRBusiness.children.push(menuItemBRBusinessReportTechData);
          //don't add social if there is the dontDoSocialTag
          if(!dontDoSocial){
              menuGroupBRBusiness.children.push(menuItemBRBusinessSocial);
          }
          menuGroupBRBusiness.children.push(menuItemBRBusinessVerifications);
          menuGroupBRBusiness.children.push(menuItemBRBusinessCloudIntegration);
          menuGroupBRBusiness.children.push(menuItemBRBusinessAttestations);
          menuGroupBRBusiness.children.push(menuItemBRBusinessShareCurrent);
      }

      //add the menu group if one of the modules above was added
      if (hasBRBusinessMenuItems) {
          navigationMenus.push(menuGroupBRBusiness);
      }

      /*  jfd*******************************
     *   CIRT menu items
         ********************************** */
    let hasCIRTMenuItems = false; //set this to true if user has anything here to add

    //only CIRT customers and staff Partners
    // if(isAdminOrStaffRole || isPartnerRole || isCustomerRole) {
    if(isAdminOrStaffRole) {
        //external threat
        if (bbDoesUserHaveAccessToModule(authUser, "perimeter") || bbDoesUserHaveAccessToModule(authUser, "monitor") || isAdminRole || isStaffRole) {
            hasCIRTMenuItems = true;

            menuGroupCIRT.children.push(menuItemPerimeterModule);
        }

        //insider threat
        if (bbDoesUserHaveAccessToModule(authUser, "insider") || isAdminRole || isStaffRole) {
            hasCIRTMenuItems = true;

            menuGroupCIRT.children.push(menuItemInsiderThreatModule);
        }

        //add the CIRT menu group if one of the modules above was added
        if (hasCIRTMenuItems) {
            menuGroupCIRT.children.push(menuItemCIRTEventLog);


            navigationMenus.push(menuGroupCIRT);
        }

        //insider threat attack inspector
        if (bbDoesUserHaveAccessToModule(authUser, "insider") || isAdminRole || isStaffRole) {
            //inspector group
            menuCollapseInspectors.children.push(menuItemAttackInspector);
            menuGroupCIRT.children.push(menuCollapseInspectors);

        }

        /*  jfd*******************************
      *   Compliance menu items
         ********************************** */
        let hasComplianceMenuItems = false; //set this to true if user has anything here to add

        //NIST 171
        if (bbDoesUserHaveAccessToModule(authUser, "nist.171") || isAdminRole || isStaffRole) {
            hasComplianceMenuItems = true;

            menuGroupCompliance.children.push(menuItemComplianceNist171);
        }

        //CMMC
        if (bbDoesUserHaveAccessToModule(authUser, "cmmc") || isAdminRole || isStaffRole) {
            hasComplianceMenuItems = true;

            menuGroupCompliance.children.push(menuItemComplianceCmmc);
        }

        //add the compliance menu group if one of the modules above was added
        if (hasComplianceMenuItems) {
            navigationMenus.push(menuGroupCompliance);
        }
    }

      /*  jfd*******************************
  *   SEttings group
     ********************************** */
      // menuGroupSettings.children.push(menuItemSettings);
      // navigationMenus.push(menuGroupSettings);


      /*  jfd*******************************
  *   Partner tasks items
     ********************************** */
      let hasPartnerMenuItems = false; //set this to true if user has anything here to add

      if(isPartnerRole) {
          hasPartnerMenuItems = true;

          menuGroupPartnerFunctions.children.push(menuItemManageUsers);
          menuGroupPartnerFunctions.children.push(menuItemManageClients);
      }

      //add the menu group if one of the modules above was added
      if (hasPartnerMenuItems && (isPartnerRole)) {
          navigationMenus.push(menuGroupPartnerFunctions);
      }

    /*  jfd*******************************
*   Administrative and Staff tasks items
   ********************************** */
    let hasAdminMenuItems = false; //set this to true if user has anything here to add

    if(isAdminRole) {
      hasAdminMenuItems = true;

        menuCollapseAdmin.children.push(menuItemAdminDashboard);
        menuCollapseAdmin.children.push(menuItemAdminExternal);
        menuCollapseAdmin.children.push(menuItemAdminInternal);
        menuCollapseAdmin.children.push(menuItemAdminSocial);
        menuGroupAdminFunctions.children.push(menuCollapseAdmin);

      menuGroupAdminFunctions.children.push(menuItemManageUsers);
      menuGroupAdminFunctions.children.push(menuItemManageClients);
    } else if(isStaffRole) {
      hasAdminMenuItems = true;

      menuGroupAdminFunctions.children.push(menuItemAdminDashboard);
      menuGroupAdminFunctions.children.push(menuItemManageUsers);
      // menuGroupAdminFunctions.children.push(menuItemAdminManageClients);
    }

    //add the menu group if one of the modules above was added
    if (hasAdminMenuItems && isAdminOrStaffRole) {
      navigationMenus.push(menuGroupAdminFunctions);
    }

  } else {
    console.warn("User is not active or doesn't have a valid role, or has no clients associated. Skipping menu links.")
  }

    menuGroupMore.children.push(menuItemSettings);
    //manage subscription page only available if user is manager for account
    if(authUserIsManager || isAdminRole){
        menuGroupMore.children.push(menuItemManageSubscription);
    }

    /*  jfd*******************************
     *   Only CIRT
         ********************************** */
    // if(isCustomer || isPartnerRole || isAdminOrStaffRole) {
        menuGroupMore.children.push(menuItemUserGuide);

        menuGroupMore.children.push(menuItemKnowledgeBase);
        menuGroupMore.children.push(menuItemFAQ);


    // }


  /*  jfd*******************************
   *   Last group: support menu items. all users, even those inactive, have access.
       ********************************** */

  menuGroupMore.children.push(menuItemContactUs);

    // menuGroupMore.children.push(menuItemKnowledgeBase);
  navigationMenus.push(menuGroupMore);

  const styledSkeleton = (width) => <SkeletonTheme baseColor="#939393" highlightColor="#444">

          <Skeleton width={width}/>

  </SkeletonTheme>

    const styledSkeletonItem = (width) => <List component="div" className='nav-menu-item'>
        <NavLink className={`prepend-icon nav-menu-link`}>
                                <span className="nav-text">
                                    {styledSkeleton(width)}
                                </span>
    </NavLink>
    </List>

    const styledSkeletonSection =
        <div className="nav-section">
            <List component="div" className={`nav-header`}>
                {styledSkeleton("65%")}
            </List>
            {styledSkeletonItem("90%")}
            {styledSkeletonItem("100%")}
            {styledSkeletonItem("70%")}
            {styledSkeletonItem("80%")}
            {styledSkeletonItem("60%")}

        </div>

    const styledSkeletonMiscSection =
        <div className="nav-section">
            <List component="div" className={`nav-header`}/>
            {styledSkeletonItem("60%")}
            {styledSkeletonItem("70%")}
            {styledSkeletonItem("15%")}
            {styledSkeletonItem("25%")}

        </div>


    const skeletonMenuSet = <>
        {styledSkeletonSection}
        {styledSkeletonSection}
        {styledSkeletonMiscSection}
    </>

  return (
    <CustomScrollbars className=" scrollbar">
        {loadingCustomers
            ? skeletonMenuSet

            : <Navigation menuItems={navigationMenus}/>
        }

    </CustomScrollbars>
  );
};

export default SideBarContent;